import React, { useState } from 'react';

const NotificationsSection = () => {
  const [settings, setSettings] = useState({
    email_new_follower: true,
    email_new_purchase: true,
    email_new_comment: true,
    email_weekly_report: true,
    email_promotions: false,
    push_new_follower: true,
    push_new_purchase: true,
    push_new_comment: true,
  });

  const handleToggle = (key) => {
    setSettings(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const notificationGroups = [
    {
      title: 'Notifications email',
      description: 'Recevez des emails pour les activités importantes',
      items: [
        { key: 'email_new_follower', label: 'Nouveau follower', description: 'Quand quelqu\'un vous suit' },
        { key: 'email_new_purchase', label: 'Nouvel achat', description: 'Quand quelqu\'un achète votre musique' },
        { key: 'email_new_comment', label: 'Nouveau commentaire', description: 'Quand quelqu\'un commente' },
        { key: 'email_weekly_report', label: 'Rapport hebdomadaire', description: 'Résumé de vos stats chaque semaine' },
        { key: 'email_promotions', label: 'Offres et promotions', description: 'Nouvelles fonctionnalités et offres spéciales' },
      ],
    },
    {
      title: 'Notifications push',
      description: 'Notifications instantanées sur votre navigateur',
      items: [
        { key: 'push_new_follower', label: 'Nouveau follower', description: 'Notifications instantanées' },
        { key: 'push_new_purchase', label: 'Nouvel achat', description: 'Soyez alerté en temps réel' },
        { key: 'push_new_comment', label: 'Nouveau commentaire', description: 'Réagissez rapidement' },
      ],
    },
  ];

  return (
    <div className="settings-section">
      <div className="settings-section-header">
        <h2 className="settings-section-title">Préférences de notification</h2>
        <p className="settings-section-description">
          Choisissez comment et quand vous souhaitez être notifié
        </p>
      </div>

      {notificationGroups.map((group) => (
        <div key={group.title} style={{ marginBottom: '2rem' }}>
          <div style={{ marginBottom: '1rem' }}>
            <h3 style={{ 
              fontSize: '1rem', 
              fontWeight: 600, 
              color: 'var(--text-primary)',
              margin: '0 0 0.25rem'
            }}>
              {group.title}
            </h3>
            <p style={{ 
              fontSize: '0.875rem', 
              color: 'var(--text-secondary)',
              margin: 0
            }}>
              {group.description}
            </p>
          </div>

          {group.items.map((item) => (
            <div key={item.key} className="notification-setting">
              <div className="notification-setting-info">
                <h4>{item.label}</h4>
                <p>{item.description}</p>
              </div>
              <div 
                className={`toggle-switch ${settings[item.key] ? 'active' : ''}`}
                onClick={() => handleToggle(item.key)}
                role="switch"
                aria-checked={settings[item.key]}
              >
                <div className="toggle-switch-thumb"></div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default NotificationsSection;
